import React, { useEffect, useState, useRef } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import ConfirmModal from "../../confirmModalV2/confirmModal";
import ChangePasswordModal from "../changePasswordModal/changePasswordModal";
import './modalEditUser.scss'
import InputAnimated from "../../inputAnimated/inputAnimated";
import Axios from "axios";
import Select from "../../select/select";
import Button from "../../button/button";
import { dataDecrypt } from "../../../utils/dataDecrypt";
import PenSVG from "../../icons/pen";
import DwgCanvas from "../../DrawingCanvas/SignatureCanva";
import { getStorage, ref, uploadString, getDownloadURL, deleteObject } from "firebase/storage";
import { PatchRegisterSignaturesToEmployee, PatchUpdateUser } from '../../../utils/Apis/superAdminApis'
const ModalEditUser = ({ modalData, setModalData, refreshTable, setRefreshTable }) => {
    const storage = getStorage();

    const [open, setOpen] = useState(false);
    // Definir las variables de estado para cada campo
    const [id, setId] = useState(null);
    const [idPerson, setIdPerson] = useState(null);
    const [employeeId, setEmployeeId] = useState(null)

    const [name, setName] = useState('');
    const [middleName, setMiddleName] = useState('');
    const [lastName, setLastName] = useState('');
    const [genre, setGenre] = useState(''); // Cambiar a cadena vacía
    const [email, setEmail] = useState(''); // Este está deshabilitado, pero igual definimos el estado
    const [phoneNumber, setPhoneNumber] = useState('');
    const [phoneNumberHome, setPhoneNumberHome] = useState('');
    const [phoneNumberOffice, setPhoneNumberOffice] = useState('');
    const [jobPosition, setJobPosition] = useState('')
    const [subsidiary, setSubsidiary] = useState('')
    const [privilege, setPrivilege] = useState(''); // Cambiar a cadena vacía
    const [subPrivilage, setSubPrivilage] = useState('')
    const [status, setStatus] = useState(''); // Cambiar a cadena vacía

    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [message, setMessage] = useState('');

    const [modalDataPassword, setModalDataPassword] = useState(null);
    const [modalDataDelete, setModalDataDelete] = useState(null);

    const [isMyAccount, setIsMyAccount] = useState(false);
    const [isUserDeleted, setIsUserDeleted] = useState(false);
    //Signature
    const drawingRef = useRef();

    const [oldEmployeeSignatureURL, setOldEmployeeSignatureURL] = useState("")
    const [signature, setSignature] = useState('');
    const [isModalOpenSignature, setIsModalOpenSignature] = useState(false);

    const [errors, setErrors] = useState({
        name: false,
        middleName: false,
        lastName: false,
        genre: false,
        email: false,
        phoneNumber: false,
        phoneNumberHome: false, // Solo valida si tiene valor
        phoneNumberOffice: false, // Solo valida si tiene valor
        jobPosition: false,
        subsidiary: false,
        privilege: false,
        sub_privilage: false,
        status: false,
    });
    const privilegeList = [
        {
            value: 1,
            label: "Alumno"
        },
        {
            value: 2,
            label: "Profesor"
        },
        {
            value: 3,
            label: "Administración"
        },
        {
            value: 4,
            label: "Dirección"
        },
        {
            value: 5,
            label: "SuperAdmin"
        },
        {
            value: 6,
            label: "Recepción"
        },
    ]
    const jobPositionList = [
        { value: 1, label: "Desarrollo de Software", storageFolder: "DEV_SOFTWARE" },
        { value: 2, label: "Desarrollo de Multimedia", storageFolder: "DEV_MULTIMEDIA" },
        { value: 3, label: "Director", storageFolder: "DIRECTOR" },
        { value: 4, label: "Recepcionista", storageFolder: "RECEPTION" },
        { value: 5, label: "Recursos Humanos", storageFolder: "RH" },
        { value: 6, label: "Auxiliar RH", storageFolder: "RH_AUX" },
        { value: 7, label: "Soporte Tecnico", storageFolder: "SUPPORT" },
        { value: 8, label: "Profesor", storageFolder: "TEACHER" },
        { value: 9, label: "Marketing", storageFolder: "MARKETING" },
    ];
    const subsidiaryList = [
        {
            value: 1,
            label: "Plaza Estrella"
        },
        {
            value: 2,
            label: "Plaza Bugambilias"
        },
        {
            value: 3,
            label: "Plaza Aranjuez"
        },
    ]
    const genreList = [
        {
            value: 1,
            label: "Hombre"
        },
        {
            value: 2,
            label: "Mujer"
        },
    ]
    const statusList = [
        {
            value: 1,
            label: "Activo"
        },
        {
            value: 2,
            label: "Inactivo"
        },
    ]
    const subPrivilageList = [
        {
            value: 1,
            label: "Encargado"
        },
        {
            value: 2,
            label: "Auxiliares"
        },
        {
            value: 3,
            label: "Auxiliares Online"
        },
    ]
    useEffect(() => {
        if (modalData !== null) {
            checkUserDeletable(modalData.id)
            setEmployeeId(modalData.employee_id);
            setId(modalData.id);
            setIdPerson(modalData.fk_person);
            setName(modalData.name);
            setMiddleName(modalData.middle_name);
            setLastName(modalData.last_name);
            setGenre(modalData.k_genre || ''); // Cambiar a cadena vacía si null
            setEmail(modalData.email);
            setPhoneNumber(modalData.phone_number);
            setPhoneNumberHome(modalData.phone_number_home || '');
            setPhoneNumberOffice(modalData.phone_number_office || '');
            setJobPosition(modalData.fk_job_position || '')
            setSubsidiary(modalData.fk_subsidiary || '')
            setPrivilege(modalData.k_privilege || ''); // Cambiar a cadena vacía si null
            setSubPrivilage(modalData.fk_sub_privilage)
            setStatus(modalData.k_status || ''); // Cambiar a cadena vacía si null
            setOldEmployeeSignatureURL(modalData.signature)
            setOpen(true);
        }
    }, [modalData]);
    useEffect(() => {
        if (isUserDeleted === true) {
            handleCloseEdit()
            setIsUserDeleted(false)
            setRefreshTable(!refreshTable)
        }
    }, [isUserDeleted])
    const handleCloseEdit = () => {
        if (drawingRef.current) {
            drawingRef.current.clearDrawing(); // Llama a la función del hijo
        }
        setSignature('')
        setOldEmployeeSignatureURL('')
        setModalData(null);
        setOpen(false);
        setButtonDisabled(false);
        setMessage('')
        setErrors({
            name: false,
            middleName: false,
            lastName: false,
            genre: false,
            email: false,
            phoneNumber: false,
            phoneNumberHome: false, // Solo valida si tiene valor
            phoneNumberOffice: false, // Solo valida si tiene valor
            jobPosition: false,
            subsidiary: false,
            privilege: false,
            sub_privilage: false,
            status: false,
        })
    }
    ///edit API

    const handleEditUser = async () => {
        // Verificar campos vacíos
        const newErrors = {
            name: !name,
            middleName: !middleName,
            lastName: !lastName,
            genre: !genre,
            email: !email,
            phoneNumber: !phoneNumber || phoneNumber.length !== 10,
            phoneNumberHome: phoneNumberHome && phoneNumberHome.length !== 10, // Solo valida si tiene valor
            phoneNumberOffice: phoneNumberOffice && phoneNumberOffice.length !== 10, // Solo valida si tiene valor
            jobPosition: !jobPosition,
            subsidiary: !subsidiary,
            privilege: !privilege,
            subPrivilage: !subPrivilage,
            status: !status,
        };
        setErrors(newErrors);

        // Verificar campos vacíos o con errores
        if (Object.values(newErrors).some((error) => error)) {
            if (!phoneNumber || phoneNumber.length !== 10) {
                setMessage("El número de teléfono debe tener exactamente 10 dígitos.");
            } else if (phoneNumberHome && phoneNumberHome.length !== 10) {
                setMessage("El número de teléfono de casa debe tener exactamente 10 dígitos.");
            } else if (phoneNumberOffice && phoneNumberOffice.length !== 10) {
                setMessage("El número de teléfono de la oficina debe tener exactamente 10 dígitos.");
            } else {
                setMessage("Todos los campos obligatorios deben ser completados.");
            }

            setTimeout(() => {
                setMessage('');
            }, 2500);
            return;
        }

        // const signature_changed = await saveSignature({ employeeId, })
        const updateUser = await PatchUpdateUser(name, middleName, lastName, email, phoneNumber, phoneNumberHome, phoneNumberOffice, genre, status, jobPosition, subsidiary, privilege, subPrivilage, id, idPerson)
        let statusResponse = updateUser.status
        switch (statusResponse) {
            case 200:
                if (signature) {
                    const signatureUrl = await saveSignature({
                        employeeId,
                        signatureDataUrl: signature,
                        jobPosition,
                        previousSignatureUrl: oldEmployeeSignatureURL
                    });
                    if (signatureUrl.status === 200) {
                        const savingSignatureDB = await PatchRegisterSignaturesToEmployee(idPerson, signatureUrl.url)
                        if (savingSignatureDB.status === 200) {

                            console.log('firma registarda en base de datos')
                        } else {
                            console.log('No se guardo la firma en la base de datos')
                        }
                    }
                }

                setMessage(updateUser.message)
                setButtonDisabled(true)
                setTimeout(() => {
                    setRefreshTable(!refreshTable);
                }, 1000);
                setTimeout(() => {
                    handleCloseEdit()
                }, 2500)
                break;
            case 201:
                setButtonDisabled(true)
                setMessage(updateUser.message)
                setTimeout(() => {
                    setMessage('')
                }, 2500);
                setButtonDisabled(false)
            case 202:
                setButtonDisabled(true)
                setMessage(updateUser.message)
                setTimeout(() => {
                    setMessage('')
                }, 2500);
                setButtonDisabled(false)
                break;
            default:
                break;
        }


    };

    const saveSignature = async ({
        employeeId, // ID único del empleado, ejemplo: EMP123
        signatureDataUrl, // Firma en base64 (data:image/png;base64,...)
        jobPosition,      // Valor numérico del puesto (1, 2, 3, ...)
        previousSignatureUrl = null // URL previa si existía firma (para poder eliminarla si cambió)
    }) => {
        if (!employeeId || !signatureDataUrl || !jobPosition) {
            console.warn("Faltan datos obligatorios para guardar la firma");
            return {
                status: 202,
                message: "Faltan datos obligatorios para guardar la firma",
                url: null
            };
        }

        // Buscar la carpeta correcta según el nuevo puesto
        const positionObj = jobPositionList.find(v => v.value === jobPosition);
        if (!positionObj) {
            console.error("No se encontró el puesto indicado");
            return {
                status: 201,
                message: "No se encontró el puesto indicado",
                url: null
            };;
        }

        const folder = positionObj.storageFolder;
        const newPath = `Signatures/EMPLOYEES/${folder}/${employeeId}_${name}_${middleName}.png`;
        const newRef = ref(storage, newPath);

        try {
            // Si había firma previa y no es del mismo folder, elimínala
            if (previousSignatureUrl && !previousSignatureUrl.includes(`/${folder}/`)) {
                const oldPath = decodeURIComponent(previousSignatureUrl.split("/o/")[1].split("?")[0]);
                const oldRef = ref(storage, oldPath);
                try {
                    await deleteObject(oldRef);
                } catch (err) {
                    if (err.code === 'storage/object-not-found') {
                        console.warn("La firma anterior no existía en Firebase, nada que eliminar.");
                    } else {
                        console.error("Error al eliminar la firma anterior:", err);
                        throw err; // Si es otro error, lo lanzamos
                    }
                }
            }

            // Subir nueva firma
            await uploadString(newRef, signatureDataUrl, 'data_url');
            const newUrl = await getDownloadURL(newRef);

            // Aquí puedes llamar a una función para actualizar tu base de datos
            // await updateEmployeeSignatureInDB(employeeId, newUrl);

            return {
                status: 200,
                message: "Firma guardada exitosamente",
                url: newUrl
            };;
        } catch (error) {
            console.error("Error al guardar la firma:", error);
            return {
                status: 500,
                message: "Error al guardar la firma",
                url: null
            };
        }
    };
    const handleKeyDown = (event) => {
        if (event.key === '+' || event.key === '-' || event.key === 'E' || event.key === 'e') {
            event.preventDefault();
        }
    };
    const handleChangePassword = () => {
        const obj = {
            id,
            email
        }
        setModalDataPassword(obj);
    }
    const handleDeleteUser = () => {
        const obj = {
            id,
            idPerson,
            email,
            action: "deleteUser",
        }
        setModalDataDelete(obj)
    }

    const checkUserDeletable = (idUser) => {
        const userStorageArray = dataDecrypt(localStorage.getItem("user"));
        if (idUser === userStorageArray.id) {
            setIsMyAccount(true)
        } else {
            setIsMyAccount(false)
        }
    }
    return (
        <Modal
            open={open}
            aria-labelledby="parent-modal-title"
            aria-describedby="parent-modal-description"
        >
            <Box className={'containerEditModal'}>
                <div className="editContainer">
                    <h1>PERFIL</h1>
                    <div className="formContainer">
                        <InputAnimated
                            maxLength={"25"}
                            type="text"
                            placeholder="Nombre"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            className={errors.name ? 'error' : ''}
                        />
                        <InputAnimated
                            maxLength={"25"}
                            type="text"
                            placeholder="Apellido Paterno"
                            value={middleName}
                            onChange={(e) => setMiddleName(e.target.value)}
                            className={errors.middleName ? 'error' : ''}
                        />
                        <InputAnimated
                            maxLength={"25"}
                            type="text"
                            placeholder="Apellido Materno"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            className={errors.lastName ? 'error' : ''}
                        />
                        <Select
                            value={genre}
                            onChange={(e) => setGenre(e.target.value)}
                            className={errors.genre ? 'error' : ''}
                            placeholder={"Selecciona un genero"}
                            options={genreList}
                        />
                        <InputAnimated
                            type="text"
                            placeholder="Email"
                            disabled
                            value={email}
                            className={errors.email ? 'error' : ''}
                        />
                        <InputAnimated
                            type="number"
                            placeholder="Teléfono"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            onInput={(e) => {
                                if (e.target.value.length > 10) {
                                    e.target.value = e.target.value.slice(0, 10);
                                }
                            }}
                            onKeyDown={handleKeyDown}
                            className={errors.phoneNumber ? 'error' : ''}
                        />
                        <InputAnimated
                            type="number"
                            placeholder="Teléfono Casa"
                            value={phoneNumberHome}
                            onChange={(e) => setPhoneNumberHome(e.target.value)}
                            onInput={(e) => {
                                if (e.target.value.length > 10) {
                                    e.target.value = e.target.value.slice(0, 10);
                                }
                            }}
                            onKeyDown={handleKeyDown}
                            className={errors.phoneNumberHome ? 'error' : ''}

                        />
                        <InputAnimated
                            type="number"
                            placeholder="Teléfono Oficina"
                            value={phoneNumberOffice}
                            onChange={(e) => setPhoneNumberOffice(e.target.value)}
                            onInput={(e) => {
                                if (e.target.value.length > 10) {
                                    e.target.value = e.target.value.slice(0, 10);
                                }
                            }}
                            onKeyDown={handleKeyDown}
                            className={errors.phoneNumberOffice ? 'error' : ''}
                        />
                        <Select
                            value={jobPosition}
                            onChange={(e) => setJobPosition(e.target.value)}
                            className={errors.jobPosition ? 'error' : ''}
                            placeholder={"Selecciona una puesto de trabajo"}
                            options={jobPositionList}
                        />
                        <Select
                            value={subsidiary}
                            onChange={(e) => setSubsidiary(e.target.value)}
                            className={errors.subsidiary ? 'error' : ''}
                            placeholder={"Selecciona un plantel"}
                            options={subsidiaryList}
                        />
                        <Select
                            value={privilege}
                            onChange={(e) => setPrivilege(e.target.value)}
                            className={errors.privilege ? 'error' : ''}
                            placeholder={"Selecciona un privilegio"}
                            options={privilegeList}
                        />
                        <Select
                            value={subPrivilage}
                            onChange={(e) => setSubPrivilage(e.target.value)}
                            className={errors.sub_privilage ? 'error' : ''}
                            placeholder={"Selecciona un sub privilegio"}
                            options={subPrivilageList}
                        />
                        <Select
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            className={errors.status ? 'error' : ''}
                            placeholder={"Selecciona un privilegio"}
                            options={statusList}
                        />
                    </div>
                    <div className='sign'>
                        <Button onClick={() => setIsModalOpenSignature(true)} text="Firma Digital" Icon={PenSVG} backgroundColor={'blue'} />
                        <DwgCanvas ref={drawingRef} isOpen={isModalOpenSignature} onClose={() => setIsModalOpenSignature(false)} setSignature={setSignature} />
                    </div>
                    <div className="changePasswordContainerSA">
                        <button onClick={handleChangePassword}>Cambiar contraseña</button>
                    </div>
                    <div className="bottomForm">

                        <Button disabled={buttonDisabled} onClick={handleCloseEdit} text={"Cancelar"} />
                        <Button disabled={buttonDisabled} onClick={handleEditUser} text={"Guardar Cambios"} />
                        <Button disabled={buttonDisabled || isMyAccount} onClick={handleDeleteUser} text={"Eliminar"} />
                    </div>
                    <div>
                        <span>{message}</span>
                    </div>
                </div>
                {/* CHILD MODAL */}
                <ChangePasswordModal
                    modalData={modalDataPassword}
                    setModalData={setModalDataPassword}
                />
                <ConfirmModal
                    modalData={modalDataDelete}
                    setModalData={setModalDataDelete}
                    setIsUserDeleted={setIsUserDeleted}
                />
            </Box>
        </Modal>
    );
}

export default ModalEditUser;
